<template>
    <DModal
        :show="showModal"
        :title="title"
        :message="message"
        is-confirm
        :is-error="action === 'delete'"
        :is-awaiting-validation="true"
        @close="$emit('close')"
        @confirm="confirm"
    />
</template>

<script setup>

defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    message: {
        type: String,
        default: ''
    },
    action: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['close', 'confirm'])

function confirm () {
    emit('confirm')
}

</script>

<style scoped lang="scss">

</style>
